/* eslint-disable no-console */
import {CheckCircleOutlined, CloseOutlined} from '@ant-design/icons';
import {Drawer, Flex, Input} from 'antd';
import React, {useEffect, useRef, useState} from 'react';

import {ReactComponent as Copilot} from '../../assets/copliot.svg';
import {drawerZIndex} from '../../constants/Common';
import copilotChat from '../../services/modules/Home/copilotChat';
import useDataStore from '../../store/dataStore/dataStore';
import useUserStore from '../../store/userStore/userStore';

import IntroText from './IntroText';
import ShowChat from './ShowChat';

const CopilotDrawer: React.FC<{open: boolean; onCancel: () => void}> = ({
  open,
  onCancel
}) => {
  const {TextArea} = Input;

  const [isEntered, setIsEntered] = useState<boolean>(false);
  const [isChatLoading, setIsChatLoading] = useState<boolean>(false);
  const [isSend, setIsSend] = useState<boolean>(false);
  const [clickToTextArea, setClickToTextArea] = useState<any>({});
  const [dubChat, setDubChat] = useState<string>('');
  const {chatStore, setChatStore} = useDataStore.getState();
  const {chatSessionId, setChatSessionId} = useUserStore.getState();
  const textAreaRef = useRef<any>(null);

  // const loremWords = [
  //   'lorem',
  //   'ipsum',
  //   'dolor',
  //   'sit',
  //   'amet',
  //   'consectetur',
  //   'adipiscing',
  //   'elit',
  //   'sed',
  //   'do',
  //   'eiusmod',
  //   'tempor',
  //   'incididunt',
  //   'ut',
  //   'labore',
  //   'et',
  //   'dolore',
  //   'magna',
  //   'aliqua'
  // ];

  // const generateLorem = (wordCount = 50) => {
  //   return Array.from(
  //     {length: wordCount},
  //     () => loremWords[Math.floor(Math.random() * loremWords.length)]
  //   ).join(' ');
  // };

  // useEffect(() => {
  //   let timeout: any;
  //   if (isSend) {
  //     setIsChatLoading(true);
  //     timeout = setTimeout(() => {
  //       setChatStore({type: 'receiver', value: generateLorem()});
  //       setIsChatLoading(false);
  //       setIsSend(false);
  //     }, 3000);
  //   }

  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [isSend]);

  const parseText = (text: string) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line.split(/(\*\*.*?\*\*)/g).map((part, i) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
          }

          return part;
        })}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    if (isSend) {
      setIsChatLoading(true);
      copilotChat(dubChat, chatSessionId)
        .then((res) => {
          if (res?.response) {
            setChatSessionId(res.session_id);
            setChatStore({type: 'receiver', value: parseText(res.response)});
          } else {
            setChatStore({
              type: 'error',
              value: 'Oops! Something Went Wrong. Try Again'
            });
          }
          setDubChat('');
          setIsChatLoading(false);
          setIsSend(false);
        })
        .catch(() => {
          setChatStore({
            type: 'error',
            value: 'Oops! Something Went Wrong. Try Again'
          });
        })
        .finally(() => {
          setIsChatLoading(false);
          setIsSend(false);
        });
    }
  }, [isSend]);

  return (
    <Drawer
      placement={'right'}
      size="large"
      destroyOnClose={false}
      open={open}
      onClose={() => {
        onCancel();
        setIsEntered(false);
      }}
      className="copilotDrawer"
      style={{padding: '0px', background: '#F3F4F8'}}
      closeIcon={false}
      zIndex={drawerZIndex}
      title={
        <Flex
          style={{
            height: '50px',
            backgroundColor: '#719A5D',
            padding: '24px',
            flex: '0 0 7%'
          }}
          align="center"
          justify="space-between"
        >
          <Flex align="center" gap={10}>
            <div
              style={{
                backgroundColor: '#FFF3EA',
                borderRadius: '50%',
                height: '48px',
                width: '48px',
                alignContent: 'center',
                textAlign: 'center'
              }}
            >
              <Copilot />
            </div>
            <Flex
              style={{
                color: '#fff',
                fontSize: '24px',
                fontWeight: 700
              }}
            >
              Net Zero Copilot
            </Flex>
            <div
              style={{
                backgroundColor: '#FFF3EA',
                borderRadius: '4px',
                height: '22px',
                width: '36px',
                alignContent: 'center',
                textAlign: 'center',
                color: '#000',
                fontWeight: 500,
                fontSize: '12px'
              }}
            >
              Beta
            </div>
          </Flex>
          <CloseOutlined
            style={{
              fontSize: '16px',
              color: '#fff',
              cursor: 'pointer'
            }}
            onClick={() => {
              onCancel();
              setIsEntered(false);
            }}
          />
        </Flex>
      }
      footer={
        <Flex style={{width: '100%'}} align="center" justify="space-between">
          <TextArea
            autoSize={{minRows: 2, maxRows: 6}}
            // style={{height: '100px', margin: '24px'}}
            placeholder="Ask me anything..."
            style={{width: '100%', margin: '10px'}}
            value={clickToTextArea?.value ?? ''}
            ref={textAreaRef}
            onKeyDown={(event) => {
              if (
                event.key === 'Enter' &&
                !event.ctrlKey &&
                !event.altKey &&
                !event.shiftKey &&
                !event.metaKey
              ) {
                if (
                  !clickToTextArea?.value ||
                  clickToTextArea?.value?.trim().length === 0
                )
                  return;
                event.preventDefault();
                setChatStore(clickToTextArea);
                setDubChat(clickToTextArea?.value);
                setClickToTextArea({});
                setIsEntered(true);
                setIsSend(true);
              }
            }}
            onChange={(e) => {
              setClickToTextArea({value: e.target.value, type: 'send'});
            }}
          />
          <CheckCircleOutlined
            style={{
              fontSize: '32px',
              height: '29px',
              cursor:
                clickToTextArea?.value?.trim().length > 0
                  ? 'pointer'
                  : 'not-allowed',
              backgroundColor: '#719A5D',
              borderRadius: '50%',
              // alignSelf: 'flex-end',
              color: '#fff',
              marginRight: '10px',
              opacity: clickToTextArea?.value?.trim().length > 0 ? 1 : 0.5
              // position: 'absolute',
              // bottom: '20%',
              // right: '4%',
            }}
            onClick={() => {
              if (
                !clickToTextArea?.value ||
                clickToTextArea?.value?.trim().length === 0
              )
                return;
              setChatStore(clickToTextArea);
              setDubChat(clickToTextArea?.value);
              setClickToTextArea({});
              setIsEntered(true);
              setIsSend(true);
            }}
          />
        </Flex>
      }
    >
      <Flex style={{height: '100%', width: '100%'}} vertical>
        <Flex
          style={{flex: '1 1 65%', backgroundColor: '#fff', width: '100%'}}
          justify={isEntered ? 'end' : 'center'}
        >
          {isEntered ? (
            <ShowChat allChat={chatStore} isChatLoading={isChatLoading} />
          ) : (
            <IntroText
              setClickToTextArea={setClickToTextArea}
              textRef={textAreaRef}
            />
          )}
        </Flex>
      </Flex>
    </Drawer>
  );
};

export default CopilotDrawer;
